import { withStyles } from '@material-ui/core';
import { compose } from 'recompose';

import { WeekSelector as LocalWeekSelector, WeekSelectorInnerProps, WeekSelectorOuterProps } from './WeekSelector';
import { weekSelectorStyles } from './weekSelectorStyles';

export const WeekSelector = compose<WeekSelectorInnerProps, WeekSelectorOuterProps>(
    withStyles(weekSelectorStyles),
)(LocalWeekSelector);
